import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VDataTable,{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.results,"items-per-page":9,"item-class":_vm.row_classes},scopedSlots:_vm._u([{key:"item.state",fn:function(ref){
var item = ref.item;
return [_c(VChip,{attrs:{"color":_vm.getColor(item.nb),"dark":""}},[_vm._v(" "+_vm._s(item.state)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }